if not App.angularApp?
    return

App.angularApp.directive 'mfTopBuffer',  ['$window', ($window) ->
    return {
        restrict: 'A'
        link: (scope, elem, attrs) =>

            resizeit = () ->
                # sidebar height - fudge + navebar 1 and 2 height
                top = parseInt(App.sidebar.element.outerHeight()) - parseInt(attrs.mfTopBuffer) + 120
                angular.element(elem).css('top', top)

            # Need to initialize on load
            resizeit()

            # resize on window resize
            angular.element($window).bind 'resize', debounce () =>
                resizeit()

    }
]
